import NewAgreementSecondPage from './NewAgreementSecondPage';

export default NewAgreementSecondPage;
